import React from "react"
import { useTranslation } from "react-i18next"
import { Box, Dialog, DialogActions, DialogContent, Typography } from "@mui/material"
import QRCode from "qrcode.react"
import { Participant } from "../../library/Participant"
import BlueButton from "../buttons/BlueButton"

interface SwitchDeviceModalProps {
  show: boolean
  participant: Participant | null
  onHide: () => void
}

export default function SwitchDeviceModal({ show, participant, onHide }: SwitchDeviceModalProps) {
  const { t } = useTranslation()

  let url = new URL(window.location.href)

  if (participant !== null) {
    url.searchParams.set("sessionId", participant.sessionId)
    if (participant.email) url.searchParams.set("email", participant.email)
    if (participant.firstName) url.searchParams.set("firstName", participant.firstName)
    if (participant.lastName) url.searchParams.set("lastName", participant.lastName)
    if (participant.phoneNumber) url.searchParams.set("phoneNumber", participant.phoneNumber)
  }

  return (
    <Dialog
      open={show}
      onClose={onHide}
      slotProps={{ paper: { sx: { borderRadius: "0.7rem", color: "#323232", maxWidth: 480 } } }}
    >
      <DialogContent sx={{ p: 3 }}>
        <Typography fontSize={28} fontWeight={500} color="text.primary">
          {t("common.switchDevice")}
        </Typography>
        <Typography sx={{ mt: 1 }}>{t("switchDevice.text")}</Typography>

        <Box sx={{ display: "flex", justifyContent: "center", mt: 2}}>
          <QRCode
            value={url.toString()}
            fgColor={"#151515"}
            size={480}
            style={{ height: "auto", maxWidth: "100%" }}
          />
        </Box>
      </DialogContent>
      <DialogActions sx={{ justifyContent: "center", p: 3, pt: 0 }}>
        <BlueButton onClick={onHide}>{t("switchDevice.buttonTitle")}</BlueButton>
      </DialogActions>
    </Dialog>
  )
}
